import dayjs, { Dayjs } from 'dayjs'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getUserbrands } from '../../../../../../redux/actions/brands'
import { assingVipContent } from '../../../../../../redux/actions/users'
import { formValidator, resetFormValidator } from '../../../../../../redux/actions/validator'
import { IRootState } from '../../../../../../redux/types'
import { IBrand, ILine, ROLES } from '../../../models/user'

interface IVipContent {
  id: null | number
  mode: string
  type: number
  line_ids: number[]
  startDate: Dayjs | null
  endDate: Dayjs | null
  startDateFormat?: string
  endDateFormat?: string
  user_id: null | number
}

export function useUserBrandsState(closeModal: () => void) {
  const dispatch = useDispatch()

  const { user: authUser } = useSelector((state: IRootState) => state.auth)
  const { userProfileSelected, vipContentSelected } = useSelector((state: IRootState) => state.user)
  const { userBrands: authUserBrands } = useSelector((state: IRootState) => state.brand)
  const { isValidForm } = useSelector((state: IRootState) => state.validator)

  const [vipContentState, setVipContentState] = useState<IVipContent>({
    id: null,
    mode: '',
    type: 1,
    line_ids: [],
    startDate: null,
    endDate: null,
    user_id: null
  })

  const [tmpBrands, setTmpBrands] = useState<IBrand[]>([])
  const [tmpBrandLines, setTmpBrandLines] = useState([])

  useEffect(() => {
    dispatch(getUserbrands())
  }, [])

  /* Cuando soy un cliente, solo puedo ver las marcas y lineas que me fueron asignadas,
sin embargo, si soy un rol diferente puedo ver las marcas que me asignaron y al mismo tiempo asignarlas.
Si soy un rol admin, puedo ver todas las marcas y asignarlas.
 */
  useEffect(() => {
    if (userProfileSelected !== null) {
      let brands: IBrand[] = []
      if (authUser.role_id !== ROLES.client && userProfileSelected.id !== authUser.id) {
        authUserBrands.forEach((authUserBrand: any) => {
          let brandVipType: number = 0
          let brandVipStatus: number = 0
          const userProfileBrand = userProfileSelected.brands.find((userProfileBrand: any) => userProfileBrand.id === authUserBrand.id)
          if (userProfileBrand) {
            brandVipType = userProfileBrand.pivot.type
            brandVipStatus = userProfileBrand.pivot.status
          }

          let lines: ILine[] = []
          authUserBrand.active_lines.forEach((authUserLine: any) => {
            let lineVipType: number = 0
            let lineVipStatus: number = 0

            const userProfileLines = userProfileSelected.brandlines.filter(
              (userProfileLine: any) => userProfileLine.brand_id === authUserBrand.id
            )
            const userProfileLine = userProfileLines.find((userProfileLine: any) => userProfileLine.id === authUserLine.id)
            if (userProfileLine) {
              lineVipType = userProfileLine.pivot.type
              lineVipStatus = userProfileLine.pivot.status
            }

            lines.push({ id: authUserLine.id, name: authUserLine.name, vipStatus: lineVipStatus, vipType: lineVipType })
          })

          brands.push({
            id: authUserBrand.id,
            name: authUserBrand.name,
            vipStatus: brandVipStatus,
            vipType: brandVipType,
            brandLines: lines
          })
        })
      } else {
        userProfileSelected.brands.forEach((userProfileBrand: any) => {
          const userProfileLines = userProfileSelected.brandlines.filter(
            (userProfileLine: any) => userProfileLine.brand_id === userProfileBrand.id
          )

          let lines: ILine[] = []
          userProfileLines.forEach((userProfileLine: any) => {
            lines.push({
              id: userProfileLine.id,
              name: userProfileLine.name,
              vipStatus: userProfileLine.pivot.status,
              vipType: userProfileLine.pivot.type
            })
          })
          brands.push({
            id: userProfileBrand.id,
            name: userProfileBrand.name,
            vipStatus: userProfileBrand.pivot.status,
            vipType: userProfileBrand.pivot.type,
            brandLines: lines
          })
        })
      }

      setTmpBrands(brands)
    }
  }, [authUserBrands, userProfileSelected])

  useEffect(() => {
    if (vipContentSelected !== null) {
      setVipContentState({
        id: vipContentSelected.id,
        mode: vipContentSelected.mode,
        type: vipContentSelected.type === null ? 1 : vipContentSelected.type,
        line_ids: tmpBrandLines.map((brandline: any) => brandline.pivot.id),
        startDate: vipContentSelected.date_ini !== null ? dayjs(vipContentSelected.date_ini) : null,
        endDate: vipContentSelected.date_end !== null ? dayjs(vipContentSelected.date_end) : null,
        user_id: vipContentSelected.user_id
      })
    }
  }, [vipContentSelected])

  useEffect(() => {
    if (isValidForm) {
      dispatch(resetFormValidator())
      let tmpData = { ...vipContentState }
      if (tmpData.type === 0) {
        tmpData.startDateFormat = dayjs(tmpData.startDate).format('YYYY-MM-DD HH:mm:ss')
        tmpData.endDateFormat = dayjs(tmpData.endDate).format('YYYY-MM-DD HH:mm:ss')
      }

      dispatch(assingVipContent(tmpData))
      handleClose()
    }
  }, [isValidForm])

  const handleClose = () => {
    closeModal()
    setVipContentState({
      id: null,
      mode: '',
      type: 1,
      line_ids: [],
      startDate: null,
      endDate: null,
      user_id: userProfileSelected.id
    })
  }

  const handleInputChange = (inputName: string, value: any) => {
    setVipContentState({ ...vipContentState, [inputName]: value })
  }

  const handleSubmit = () => {
    dispatch(
      formValidator({
        type: [vipContentState.type, 'numeric', 'general']
      })
    )
  }

  return {
    vipContentState,
    tmpBrands,
    setTmpBrands,
    tmpBrandLines,
    setTmpBrandLines,
    handleInputChange,
    handleClose,
    handleSubmit
  }
}
